import { useEffect } from 'react'

import { Markers } from '#/components/Maps/Markers/types'

interface AutoFitBoundsProps {
  markers: Markers
  map: google.maps.Map | null
}

export function useAutoFitBounds({ map, markers }: AutoFitBoundsProps) {
  // Extrai todas as posições (lat/lng) dos marcadores para ajustar os limites do mapa
  const positions = getAllLatLng(markers)

  useEffect(() => {
    // Se o mapa não estiver disponível ou não houver posições, não faz nada
    if (!map || positions.length === 0) return

    // Cria uma instância de LatLngBounds para calcular os limites
    const bounds = new window.google.maps.LatLngBounds()

    // Estende os limites com cada posição fornecida
    positions.forEach(pos => {
      bounds.extend({ lat: Number(pos.lat), lng: Number(pos.lng) })
    })

    // Ajusta o mapa para caber dentro dos limites calculados
    map.fitBounds(bounds)
  }, [map]) // Executa novamente se o mapa ou as posições mudarem

  return null
}

// Função que extrai todos os pares de coordenadas { lat, lng } de um objeto genérico
function getAllLatLng(data: Record<string, any>): { lat: number; lng: number }[] {
  return Object.values(data ?? {}).flatMap(group =>
    Array.isArray(group)
      ? group
          // Filtra os itens que possuem propriedades lat e lng do tipo número
          .filter(item => typeof item?.lat === 'number' && typeof item?.lng === 'number')
          // Mapeia os itens para um novo objeto contendo apenas lat e lng
          .map(item => ({ lat: item.lat, lng: item.lng }))
      : [],
  )
}
